import { faArrowRightFromBracket } from '@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket';
import { Link } from '@tanstack/react-router';
import useResponsive from 'ahooks/es/useResponsive';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Button } from '@furality/furality-purpose';
import FontAwesomeIcon from '@/components/FontAwesomeIcon.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

import TooltipHelper from '../TooltipHelper.tsx';

type Props = {
  eventId: string;
};
const JoinDealersWorldButton = ({ eventId }: Props) => {
  const { t } = useTranslation(['common', 'dealers']);
  const { lg, xl } = useResponsive();

  const dealersWorldDelayed = useFlag('dealersDen.worldDelayed');

  return (
    <TooltipHelper
      id="join-dealers-world"
      title={
        dealersWorldDelayed
          ? t(
              // TODO: own key
              'f7.schedule.view.dealers_soon',
            )
          : t('dealers:join.tooltip')
      }
      child={
        <Button
          variant={dealersWorldDelayed ? 'secondary' : 'primary'}
          size={xl ? 'xl' : undefined}
          className={clsx('text-white mr-0', lg ? 'position-absolute' : 'd-block mb-4')}
          as={Link}
          href={`/event?id=${eventId}`}
          // TODO Refactor:
          style={{
            ...(lg && {
              top: '3rem',
              right: '1rem',
            }),
          }}
          disabled={dealersWorldDelayed}
        >
          {dealersWorldDelayed ? (
            t(
              // TODO: own key
              'f7.schedule.view.dealers_soon',
            )
          ) : (
            <>
              <span className="me-2">{t('dealers:join')}</span>
              <FontAwesomeIcon icon={faArrowRightFromBracket} className="ms-3" />
            </>
          )}
        </Button>
      }
    />
  );
};

export default JoinDealersWorldButton;
